import script from "./ProfileSetupPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileSetupPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileSetupPage.vue?vue&type=style&index=0&id=433d6924&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-433d6924"]])

export default __exports__